import { Grid, Link } from "@mui/material";

export default function InvoiceFormThanksPage() {
    return (
        <Grid container justifyContent={"center"} alignItems={"center"} height={"100%"} textAlign={"center"}>
            <Grid item>
                <h2>Your invoice submission was successful!</h2>
                <Link href={"/ap/invoice"}>Send another?</Link>
            </Grid>
        </Grid>
    )
}